import AuthTabs from "./auth-tabs/AuthTabs";
import {useTranslation} from "react-i18next";
import {Facebook} from "@mui/icons-material";
import {alpha, Divider} from "@mui/material";
import Grid from "@mui/material/Grid";
import googleLogo from '../../assets/images/google-icon.svg'
import React from "react";
import Typography from "@mui/material/Typography";
import {SocialLoginType} from "../../util/constants";
import {useAppDispatch} from "../../store";
import {socialLoginUser} from "../../store/auth/ActionCreators";
import ReactGA from "react-ga4";
import {LoginSocialFacebook, LoginSocialGoogle} from "reactjs-social-login"
import IconButton from "@mui/material/IconButton";
import {useTheme} from "@mui/material/styles";

const Auth = () => {
    const {t} = useTranslation()
    const dispatch = useAppDispatch()
    const theme = useTheme()

    const responseGoogle = (response: any) => {
        if (!('access_token' in response?.data)) {
            return
        }

        ReactGA.event("login", {method: "Google"})
        dispatch(socialLoginUser({token: response.data.access_token, type: SocialLoginType.GOOGLE}))
    }

    const responseFacebook = (response: any) => {
        if (!('accessToken' in response?.data)) {
            return
        }

        ReactGA.event("login", {method: "Facebook"})
        dispatch(socialLoginUser({token: response.data.accessToken, type: SocialLoginType.FACEBOOK}))
    }

    const handleFacebookError = (res: any) => {
        console.error("Error during Facebook login", res)
    }

    const handleGoogleError = (res: any) => {
        console.error("Error during Google login", res)
    }

    return (
        <>
            <AuthTabs/>
            <Grid container my="1em" alignItems="center">
                <Divider sx={{
                    display: "flex",
                    flex: 1,
                    background: `linear-gradient(to right, ${alpha(theme.palette.primary.main, .7)}, ${alpha(theme.palette.primary.main, 0)})`,
                    height: `2px`
                }}/>
                <Typography variant="body2" color='primary' paddingX="1em">{t('or_login_with')}</Typography>
                <Divider sx={{
                    display: "flex",
                    flex: 1,
                    background: `linear-gradient(to left, ${alpha(theme.palette.primary.main, .7)}, ${alpha(theme.palette.primary.main, 0)})`,
                    height: `2px`
                }}/>
            </Grid>
            <Grid container justifyContent='center' spacing={2}>
                <Grid>
                    <LoginSocialGoogle client_id={process.env.REACT_APP_GOOGLE_AUTH2_API_KEY as string}
                                       onReject={handleGoogleError} onResolve={responseGoogle}
                                       cookie_policy="single_host_origin" isOnlyGetToken scope="openid profile email">
                        <IconButton size="large" color="primary" sx={{
                            background: 'white',
                            '&:hover': {
                                backgroundColor: 'rgb(178, 178, 178)',
                            },
                        }}>
                            <img alt='google-icon' src={googleLogo} width={35}/>
                        </IconButton>
                    </LoginSocialGoogle>
                </Grid>
                <Grid>
                    <LoginSocialFacebook appId={process.env.REACT_APP_FACEBOOK_AUTH2_API_KEY as string}
                                         onReject={handleFacebookError} onResolve={responseFacebook} isOnlyGetToken>
                        <IconButton size="large" color="primary" sx={{
                            background: '#3B5998',
                            '&:hover': {
                                backgroundColor: '#2A4475',
                            }
                        }}>
                            <Facebook fontSize='large'/>
                        </IconButton>
                    </LoginSocialFacebook>
                </Grid>
            </Grid>
        </>
    );
}

export default Auth
